import { useCallback, useRef } from "react";
import { registerMobileScrollReveal, type MobileRevealKind } from "@/lib/mobile-scroll-reveal";
import "@/components/motion/mobile-scroll-reveal.css";

/** Adds motion to an existing element; introduces no DOM wrapper or React scroll state. */
export function useMobileScrollReveal<T extends HTMLElement = HTMLDivElement>(
  kind: MobileRevealKind = "copy",
) {
  const cleanup = useRef<(() => void) | undefined>(undefined);
  // Callback refs also handle sections that appear after async data resolves.
  return useCallback((element: T | null) => {
    cleanup.current?.();
    cleanup.current = element ? registerMobileScrollReveal(element, kind) : undefined;
  }, [kind]);
}
